import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UniversalSelect } from '@feathr/components';

import type { EDateMatchMode, IDateMatchOption } from './CampaignDateMatchSelect.utils';
import {
  dateMatchModeHelpMap,
  defaultDateMatchMode,
  getDateMatchOptions,
} from './CampaignDateMatchSelect.utils';

interface IProps {
  onChange: (value: EDateMatchMode) => void;
  value?: EDateMatchMode;
}

function CampaignDateMatchSelect({ onChange, value }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  const mode = value ?? defaultDateMatchMode;
  const options = getDateMatchOptions(t);

  function handleSelectMode(option: IDateMatchOption): void {
    onChange(option.id);
  }

  return (
    <UniversalSelect<IDateMatchOption>
      /*
       * `bottom` keeps the control anchored when the (mode-dependent) help text
       * changes length — same treatment as the expiration select in
       * CreateAPIKeyModal, the other select whose help text tracks its value.
       */
      helpPlacement={'bottom'}
      helpText={dateMatchModeHelpMap(t)[mode]}
      isClearable={false}
      label={t('Date match')}
      name={'campaign-date-match-select'}
      onSelectSingle={handleSelectMode}
      options={options}
      value={options.find(({ id }) => id === mode)}
    />
  );
}

export default CampaignDateMatchSelect;
